import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const LightTooltip = withStyles(theme => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: '#212121',
      boxShadow: theme.shadows[1],
      maxWidth: '150px',
    },
  }))(Tooltip);

  export default LightTooltip